import React from 'react';

const ArrowRightIcon = () => (
  <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
    <path d="M4 11.25a.75.75 0 0 0 0 1.5h14.19l-3.72 3.72a.75.75 0 0 0 1.06 1.06l4.317-4.317c.145-.145.302-.302.417-.452a1.24 1.24 0 0 0 .279-.761c0-.334-.145-.585-.28-.761a4.843 4.843 0 0 0-.416-.452L15.53 6.47a.75.75 0 0 0-1.06 1.06l3.72 3.72H4Z" />
  </svg>
);

export default ArrowRightIcon;
